import { FunctionComponent } from "react";
import styles from "./EmbedConsent.module.scss";
import strings from "./strings";

const { contentUnavailable, privacySettings, privacyUrl } = strings;

const EmbedConsent: FunctionComponent = () => {
  const contentEmbedCard = (
    <div className={styles.blockedContentCard}>
      <div className={styles.loadedCard}>
        <div className={styles.blockedContentAlert}>
          <img
            alt="info icon"
            className={styles.infoIcon}
            src={"/static/icons/icons_info_black_outline.svg"}
          ></img>
        </div>
        <div className={styles.blockedContentBody}>
          {contentUnavailable}
          {"true" === process.env.NEXT_PUBLIC_DISABLE_YAHOO_PRIVACY ? null : (
            <a className="embed-privacy-settings" href={privacyUrl}>
              {privacySettings}
            </a>
          )}
        </div>
      </div>
    </div>
  );

  return (
    <div className={styles.thirdPartyEmbedConsent}>{contentEmbedCard}</div>
  );
};

export default EmbedConsent;
